import { Badge, Card, Image, Space, Stack, Text } from "@mantine/core"
import { DesignStudioParametersToolkit } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { PublicResponses } from "@tfg/types/endpoints/public"
import {
  productCardBadgeBackgroundColorCSSVariable,
  productCardBadgeTextColorCSSVariable,
  searchEngineTextColorCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"

import hanger from "~/assets/images/hanger.svg"
import shoe from "~/assets/images/shoe.svg"
import { useProductSheetUrl } from "~/pages/Public/hooks"

type Props = {
  product: PublicResponses.ProductCard
}

export const ProductCard = ({ product }: Props) => {
  const { t } = useTranslation("public")
  const textColor = DesignStudioParametersToolkit.getCssVariableLiteralName(
    searchEngineTextColorCSSVariable
  )

  const productSheetUrl = useProductSheetUrl(product.agecPopinUrl ?? "")
  return (
    <Card
      radius="md"
      withBorder
      component="a"
      href={productSheetUrl}
      target="_blank"
    >
      <Card.Section>
        <Image
          src={product.picture}
          alt={product.name}
          fit="contain"
          h={240}
          fallbackSrc={product.type.includes("FOOTWEAR") ? shoe : hanger}
        />
      </Card.Section>
      <Stack gap="lg" mt="xs" justify="space-between">
        <Stack gap={1}>
          <Text fw={600} c={textColor}>
            {product.name}
          </Text>
          <Text fw={600} c={textColor}>
            {product.brand}
          </Text>
        </Stack>

        <Stack gap={4} align="flex-start" justify="flex-end">
          {product.collection ? (
            <Badge
              bg={DesignStudioParametersToolkit.getCssVariableLiteralName(
                productCardBadgeBackgroundColorCSSVariable
              )}
              c={DesignStudioParametersToolkit.getCssVariableLiteralName(
                productCardBadgeTextColorCSSVariable
              )}
            >
              {product.collection}
            </Badge>
          ) : (
            <Space h={20} />
          )}
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text fw={400} c={textColor}>
              {t("productCard.reference")}
            </Text>
            <Text fw={700} c={textColor}>
              {product.brandReference}
            </Text>
          </Stack>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text fw={400} c={textColor}>
              {t("productCard.productType")}
            </Text>
            <Text fw={700} c={textColor}>
              {product.brandType}
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
